import { FC, ReactNode, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { DialogNames } from './types';

type Props = {
  children: ReactNode;
  name: DialogNames;
};
/**
 * DialogContainer Component:
 *
 * it creates a ReactPortal at the root of the HTML document as a div Element and injects the children as its content.
 *
 * @param children ReactNode
 * @param name id of the created div
 * @returns ReactPortal
 */
export const DialogContainer: FC<Props> = ({ children, name }) => {
  const [container] = useState(() => {
    return document.createElement('div');
  });

  useEffect(() => {
    container.id = name!;
    document.body.appendChild(container);
    return () => {
      document.body.removeChild(container);
    };
  }, [container, name]);

  return ReactDOM.createPortal(children, container);
};

DialogContainer.displayName = 'DialogContainer';
